import React, { useState, useEffect } from "react";
import {
  useReactTable,
  getCoreRowModel,
  getSortedRowModel,
  flexRender,
} from "@tanstack/react-table";
import {
  history,
  editPencilIcon,
  deleteIconDark,
} from "../../../assetData/icons";

const ManageMenuTable = (props) => {
  const {
    columns,
    tableData,
    setSelectedItemId,
    scrollDown,
    setSelectedId,
    setIsDelete,
  } = props;
  const [data, setData] = useState([]);

  const customTable = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
  });

  React.useEffect(() => {
    if (customTable.getState().columnFilters[0]?.id === "fullName") {
      if (customTable.getState().sorting[0]?.id !== "fullName") {
        customTable.setSorting([{ id: "fullName", desc: false }]);
      }
    }
  }, [customTable.getState().columnFilters[0]?.id]);

  const handleEditClick = (id) => {
    setSelectedItemId(id);
  };

  React.useEffect(() => {
    if (tableData) setData(tableData);
  }, [tableData]);

  useEffect(() => {
    if (scrollDown) {
      setTimeout(() => {
        const tableBody = document.querySelector(".scrollbar-custom");
        if (tableBody) {
          tableBody.scrollTo({
            top: tableBody.scrollHeight,
            behavior: "smooth",
          });
        }
      }, 50);
    }
  }, [scrollDown]);

  if (!data) return null;

  return (
    <div className="mt-8 flex w-full flex-col gap-2">
      <div className=" scrollbar-custom overflow-x-scroll  ">
        <table className="w-full">
          <thead className="block bg-pri-clr-blue">
            {customTable.getHeaderGroups().map((headerGroup) => (
              <tr key={headerGroup.id}>
                {headerGroup.headers.map((header) => (
                  <th
                    key={header.id}
                    className=" w-fit py-2 text-start text-[12px] uppercase text-white"
                  >
                    {header.isPlaceholder
                      ? null
                      : flexRender(
                          header.column.columnDef.header,
                          header.getContext(),
                        )}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <thead className="h-2">
            <tr></tr>
          </thead>
          <tbody className="scrollbar-custom block max-h-[400px] w-full overflow-y-scroll border-[1px] border-neutral-clr-300 pt-2">
            {customTable.getRowModel().rows.map((row) => (
              <>
                <tr>
                  {row.getVisibleCells().map((cell) => (
                    <td
                      key={cell.id}
                      className="h-[26px] w-fit border-[1px]  border-neutral-clr-300 px-1 text-[14px] text-black"
                    >
                      {flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext(),
                      )}
                      {cell.id.split("_")[1] === "icons" && (
                        <div className="flex items-center justify-evenly [&>button]:shrink-0">
                          <div className="relative">
                            <img
                              src={history}
                              alt="i4invest"
                              className="w-[15px]"
                            />
                          </div>
                          <div>
                            <img
                              src={editPencilIcon}
                              alt="i4invest"
                              className="w-[15px] cursor-pointer"
                              onClick={() => handleEditClick(row.index)}
                            />
                          </div>
                          <div>
                            <img
                              src={deleteIconDark}
                              alt="i4invest"
                              className="w-[16px] cursor-pointer"
                              onClick={() => (
                                setSelectedId(row.original.id),
                                setIsDelete(true)
                              )}
                            />
                          </div>
                        </div>
                      )}
                    </td>
                  ))}
                </tr>
              </>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ManageMenuTable;
